/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

const TECHFALA_BRAND = 'TechFala';

const normalizeInstallationName = rawName => {
  const name = rawName?.toString().trim();
  if (!name || /^chatwoot$/i.test(name) || name === 'Chat') {
    return TECHFALA_BRAND;
  }
  return name.replace(/Chatwoot/gi, TECHFALA_BRAND);
};

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Substitui referências upstream "Chatwoot" / "Chat - techfala" pelo nome da instalação.
   * Se o banco ainda tiver INSTALLATION_NAME=Chatwoot (regressão comum após upgrade), força TechFala.
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = normalizeInstallationName(
      globalConfig.value?.installationName
    );

    return text
      .replace(/Chatwoot/gi, installationName)
      .replace(/Chat - techfala/gi, installationName);
  };

  return {
    replaceInstallationName,
  };
}
